import { IStaticStylesConfig } from "./_primitives/IStaticStylesConfig";

export const MatwinsV1: IStaticStylesConfig = {
  btnPrimary: 'bg-teal-500 hover:bg-teal-600 text-white font-medium rounded-sm text-xs transition-colors flex items-center',
  btnSecondary: 'bg-blue-500 hover:bg-blue-600 text-white font-medium rounded-sm text-xs transition-colors flex items-center',
  btnAlert: 'bg-orange-500 hover:bg-orange-600 text-white font-medium rounded-sm text-xs transition-colors flex items-center',

  btnPrimaryXs: 'bg-teal-500 hover:bg-teal-600 text-white font-medium rounded-sm text-[0.625em] transition-colors flex items-center',
  btnSecondaryXs: 'bg-blue-500 hover:bg-blue-600 text-white font-medium rounded-sm text-[0.625em] transition-colors flex items-center',
  btnAlertXs: 'bg-orange-500 hover:bg-orange-600 text-white font-medium rounded-sm text-[0.625em] transition-colors flex items-center',

  btnPrimaryLg: 'bg-teal-500 hover:bg-teal-600 text-white font-medium rounded-sm text-lg transition-colors flex items-center',
  btnSecondaryLg: 'bg-blue-500 hover:bg-blue-600 text-white font-medium rounded-sm text-lg transition-colors flex items-center',
  btnAlertLg: 'bg-orange-500 hover:bg-orange-600 text-white font-medium rounded-sm text-lg transition-colors flex items-center',

  btnPrimaryXl: 'bg-teal-500 hover:bg-teal-600 text-white font-medium rounded-sm text-2xl transition-colors flex items-center',
  btnSecondaryXl: 'bg-blue-500 hover:bg-blue-600 text-white font-medium rounded-sm text-2xl transition-colors flex items-center',
  btnAlertXl: 'bg-orange-500 hover:bg-orange-600 text-white font-medium rounded-sm text-2xl transition-colors flex items-center',

  btnPrimaryXXl: 'bg-teal-500 hover:bg-teal-600 text-white font-medium rounded-sm text-5xl transition-colors flex items-center',
  btnSecondaryXXl: 'bg-blue-500 hover:bg-blue-600 text-white font-medium rounded-sm text-5xl transition-colors flex items-center',
  btnAlertXXl: 'bg-orange-500 hover:bg-orange-600 text-white font-medium rounded-sm text-5xl transition-colors flex items-center',

  detailContainer: 'bg-stone-50 rounded-xs shadow-md border border-gray-200 mt-0 max-h-[calc(100vh-60px)] overflow-y-auto relative p-6',
  detailQrCodeContainer: 'bg-stone-50 rounded-xs shadow-md border border-gray-200 mt-0 relative p-6',
  cardContainer: 'bg-white shadow-md rounded-lg p-4 border border-gray-200',
  textError: 'text-red-500 text-sm font-semibold',
  formSectionSmallTitle: 'text-s font-s text-gray-700 mb-3 pb-1 border-b border-gray-700 font-montserrat',
  formSectionSmallTitleSpan: 'text-s font-s text-gray-700 font-montserrat',
  upperCaseSmallLabel: 'block text-[0.68em] font-medium text-gray-500 mt-6 mb-1 uppercase tracking-wide',
  upperCaseSmallLabelCheckbox: 'block text-[0.68em] font-medium text-gray-500 uppercase tracking-wide cursor-pointer',
  formInputSmallSize: 'w-full p-1 border border-gray-300 rounded-sm text-sm text-gray-500',
  formInputMediumSize: 'w-full p-1 border border-gray-300 rounded-sm text-lg text-gray-500',
  formInputLargeSize: 'w-full p-1 border border-gray-300 rounded-sm text-xl text-gray-500',
  formInputVeryLargeSize: 'w-full p-1 border border-gray-300 rounded-sm text-3xl text-gray-500',
  formInputExtraLargeSize: 'w-full p-1 border border-gray-300 rounded-sm text-5xl text-gray-500',

  containerBadge: 'inline-flex items-center justify-center px-3 py-1 select-none text-center',
  containerMultiSelectBadge: 'flex items-center justify-center gap-2 px-3 py-1 select-none text-center truncate w-[26ch] relative h-[30px] pr-7',
  badge: 'truncate w-[10ch]',
  multiSelectbadge: 'leading-normal truncate',
  icon: 'text-[12px]',
  square: 'rounded-none',
  rounded: 'rounded-full',
  danger: 'bg-red-500 text-white',
  success: 'bg-green-500 text-white',
  warning: 'bg-yellow-500 text-black',
  default: 'bg-grey-500 text-black',
  primary: 'bg-grey-500 text-white',
  secondary: 'bg-grey-500 text-white',
  info: 'bg-sky-200 text-black',
  light: 'bg-white text-black',
  dark: 'bg-grey-900 text-white',

  squareRonded: 'px-3 py-1 text-sm rounded-md transition-colors',
  filterDanger: 'border border-red-600 bg-red-600 text-white font-medium',
  filterSuccess: 'border border-green-600 bg-green-600 text-white font-medium',
  filterWarning: 'border border-yellow-600 bg-yellow-600 text-white font-medium',
  filterInfo: 'border border-sky-600 bg-sky-600 text-white font-medium',
  filterDangerUnselected: 'bg-red-100 border border-red-300 text-black hover:bg-red-200 text-red-700',
  filterSuccessUnselected: 'bg-green-100 border border-green-300 text-black hover:bg-green-200 text-green-700',
  filterWarningUnselected: 'bg-yellow-100 border border-yellow-300 text-black hover:bg-yellow-200 text-yellow-700',
  filterInfoUnselected: 'bg-sky-100 border border-sky-300 text-black hover:bg-sky-200 text-sky-700',

  multiSelectContainer: 'relative w-full max-w-md mx-auto',
  multiselectSelected: 'w-full min-h-12 px-2 py-2 bg-white border border-gray-300 rounded-lg shadow-sm cursor-pointer flex flex-wrap items-center gap-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500',

} as const;


//  j'override la version de base 
export const QrCodeCheckinV1: IStaticStylesConfig = {
  ...MatwinsV1,

  btnPrimary: 'bg-blue-500 hover:bg-blue-600 text-white font-medium rounded-sm text-[1em] transition-colors flex items-center',
  btnSecondary: 'bg-blue-500 hover:bg-purple-600 text-white font-medium rounded-sm text-[1em] transition-colors flex items-center',

  btnPrimaryXs: 'bg-blue-500 hover:bg-blue-600 text-white font-medium rounded-sm text-[0.625em] transition-colors flex items-center',
  btnSecondaryXs: 'bg-blue-500 hover:bg-purple-600 text-white font-medium rounded-sm text-[0.625em] transition-colors flex items-center',

  btnPrimaryLg: 'bg-blue-500 hover:bg-blue-600 text-white font-medium rounded-sm text-lg transition-colors flex items-center',
  btnSecondaryLg: 'bg-blue-500 hover:bg-purple-600 text-white font-medium rounded-sm text-lg transition-colors flex items-center',

  btnPrimaryXl: 'bg-blue-500 hover:bg-blue-600 text-white font-medium rounded-sm text-2xl transition-colors flex items-center',
  btnSecondaryXl: 'bg-blue-500 hover:bg-purple-600 text-white font-medium rounded-sm text-2xl transition-colors flex items-center',

  btnPrimaryXXl: 'bg-blue-500 hover:bg-blue-600 text-white font-medium rounded-sm text-5xl transition-colors flex items-center',
  btnSecondaryXXl: 'bg-blue-500 hover:bg-purple-600 text-white font-medium rounded-sm text-5xl transition-colors flex items-center',

  formInputSmallSize: 'w-full p-1 border border-gray-300 rounded-md text-sm text-gray-500',
  formInputMediumSize: 'w-full p-1 border border-gray-300 rounded-md text-lg text-gray-500',
  formInputLargeSize: 'w-full p-1 border border-gray-300 rounded-md text-xl text-gray-500',
  formInputVeryLargeSize: 'w-full p-1 border border-gray-300 rounded-md text-3xl text-gray-500',
  formInputExtraLargeSize: 'w-full p-1 border border-gray-300 rounded-md text-5xl text-gray-500',

  badge: 'truncate w-[10ch]',
  // badge: 'py-1 px-3 text-xs text-center mx-7 w-[20ch] truncate inline-block select-none bg-purple-500 text-white',
};

//  j'override la version de base 
export const IpadCheckinV1: IStaticStylesConfig = {
  ...MatwinsV1,
  // Label sous l'input
  upperCaseSmallLabel: 'block text-base font-medium text-gray-500 mt-1 mb-6 normal-case tracking-normal text-left',

  // Inputs : bordure basse, texte aligné à gauche
  formInputSmallSize: 'w-full py-3 px-2 border-0 border-b-2  bg-transparent text-lg text-gray-700 text-left focus:outline-none',
  formInputMediumSize: 'w-full py-3 px-2 border-0 border-b-2  bg-transparent text-xl text-gray-700 text-left focus:outline-none',
  formInputLargeSize: 'w-full py-4 px-2 border-0 border-b-2  bg-transparent text-2xl text-gray-700 text-left focus:outline-none',
  formInputVeryLargeSize: 'w-full py-4 px-2 border-0 border-b-2  bg-transparent text-3xl text-gray-700 text-left focus:outline-none',
  formInputExtraLargeSize: 'w-full py-4 px-2 border-0 border-b-2  bg-transparent text-5xl text-gray-700 text-left focus:outline-none',

  multiSelectContainer: 'relative w-full',
  multiselectSelected: 'w-full min-h-12 px-2 py-2 border-b-2 cursor-pointer flex flex-wrap items-center gap-2',
};



export const MatwinsSkins = {
  V1: MatwinsV1,
  QrCode1: QrCodeCheckinV1,
  Ipad1: IpadCheckinV1
}
